<template>
  <div class="modal-content-poll">
    <div class="modal-header">
      <h2>Izmeni glasanje</h2>
    </div>
    <div class="body">
      <form class="form--mod" action="post">
        <div id="section">
          <div id="desc-area">
            <label class="col-form-label col-form-label-lg"
              >Opis glasanja</label
            >
            <textarea
              v-model="poll.body"
              class="form-control"
              rows="5"
              id="comment"
              @focus="errorOccurred = false"
              ref="descArea"
            ></textarea>
          </div>
          <div id="upload-area">
            <label class="col-form-label col-form-label-lg">Datoteke</label>
            <div id="uploaded-files">
              <div
                id="empty-files"
                v-if="poll.medias == null || poll.medias.length === 0"
              >
                <p>Trenutno nemate dodatih datoteka</p>
              </div>
              <div
                class="file"
                v-for="(file, index) of poll.medias"
                :key="index"
              >
                <p>{{ file.file_name }}</p>
                <i
                  class="fas fa-times del--mod"
                  @click="removeUploadedFile(index)"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </form>
      <span class="txt-pin">Pinovana objava</span>
      <checkbox
        size="small"
        :checked="poll.is_pinned == '1'"
        @change.native="togglePin()"
      ></checkbox>
    </div>

    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>

      <div class="buttons" style="text-align:center">
        <button
          type="submit"
          class="btn btn-danger btn--mod"
          @click="closeModal"
        >
          Otkaži
        </button>
        <button
          type="submit"
          class="btn btn-primary btn--mod"
          @click="editForm"
        >
          <span v-if="!loading">Pošalji</span>
          <spinner line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapMutations, mapActions, mapState } from 'vuex';
import checkbox from '@/components/common/Checkbox.vue';

export default {
  components: {
    checkbox
  },
  data() {
    return {
      errorOccurred: false,
      errorMessage: ''
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('modal', ['poll'])
  },
  methods: {
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapActions('table', ['getPollsByCommunity', 'getAllPolls']),
    ...mapMutations('modal', ['closeModal', 'setPoll']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapMutations(['setPostTitle']),
    removeUploadedFile(index) {
      this.poll.medias.splice(index, 1);
    },
    togglePin() {
      if (this.poll.is_pinned == '1') {
        this.poll.is_pinned = '0';
      } else {
        this.poll.is_pinned = '1';
      }
    },
    editForm() {
      if (this.poll.body === '') {
        this.errorOccurred = true;
        this.errorMessage = 'Morate popuniti polje opisa';
      } else {
        this.loadingStarted();
        axios
          .post('/post/edit', {
            body: this.poll.body,
            post_id: this.poll.id,
            media_ids: this.poll.medias
              ? this.poll.medias.map(el => el.id)
              : null
          })
          .then(async data => {
            try {
              await axios.post('/post/pin', {
                member_id: this.$store.getters.getActiveCommunity.member_id,
                post_id: this.poll.id,
                pin: this.poll.is_pinned == '1' ? true : false
              });
            } catch (error) {
              console.log(error);
              this.setPostTitle('Glasanje');
              this.showFailModal();
              this.loadingFinished();
            }
            this.loadingFinished();
            if (this.$router.history.current.name === 'communityPolls') {
              if (this.$store.state.table.pollsFilter) {
                this.getPollsByCommunity({
                  communityId: this.$store.getters.getActiveCommunity.id,
                  memberId: this.$store.getters.getActiveCommunity.member_id
                });
              } else {
                this.getPollsByCommunity({
                  communityId: this.$route.params.id
                });
              }
            } else {
              this.getAllPolls();
            }
            // this.setPostTitle(this.poll.body);
            this.setPostTitle('Glasanje');
            this.closeModal();
            this.showSuccessModal();
          })
          .catch(err => {
            console.log(err);
            this.showFailModal();
            this.loadingFinished();
          });
      }
    }
  }
};
</script>

<style lang="scss">
.modal-content-poll {
  .body {
    height: 100%;
    width: 100%;
  }

  .form--mod {
    justify-content: center;
  }

  .footer {
    display: block;
    width: 100%;
    text-align: center;
  }
  .buttons {
    display: inline-flex;
    float: right;
  }

  .error {
    float: left;
    margin-left: 15px;
  }

  .btn--mod {
    margin-left: 15px;
  }

  .btn-primary:hover {
    background-color: var(--primary-color-lighten);
  }

  .file {
    border-bottom: solid 1px lightgray;
    font-size: 15px;
    width: 100%;
    display: inline-flex;
    vertical-align: center;
    p {
      max-width: 155px;
      word-wrap: break-word;
      margin-bottom: 2px;
      word-break: break-all;
    }
  }

  .btn-primary:active {
    background-color: var(--primary-color) !important;
    border: none;
  }

  .btn-primary:focus {
    box-shadow: 0 0 0 0.2rem var(--primary-color-lighten) !important;
  }

  textarea.form-control {
    resize: none;
    width: 100%;
  }

  #desc-area {
    width: 66%;
  }

  #section {
    display: inline-flex;
    width: 100%;
    height: 100%;
  }

  .del--mod {
    margin-left: auto;
    cursor: pointer;
    color: red;
    top: 4.7em;
    right: 1.7em;
  }

  #empty-files {
    text-align: center;
    color: grey;
    margin-top: 20%;
  }

  .col-form-label-lg {
    width: 100%;
    position: relative;
  }

  input {
    margin-bottom: 9px;
    position: relative;
  }

  #uploaded-files {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    height: 135px;
    resize: none;
    max-height: 134px;
    overflow-y: auto;
    padding: 5px;
  }

  #upload-area {
    display: block;
    margin-left: 9px;
    width: 34%;
    height: 100%;
  }

  .err-msg {
    text-align: center;
    color: red;
  }
  .form-control {
    margin-left: 2px;
  }
}
</style>
